<template>
  <div class="modal_card">
    <div class="header">
      <h4 class="title">
        {{ translate('services.blocked_simcard.add_blocked_simcard') }}
      </h4>
    </div>
    <div class="content">
      <div class="row">
        <div class="col-md-12">
          <label>
            {{ translate('services.blocked_simcard.reason') }}
          </label>
          <tree-select
              :options="reason_list"
              v-model="reason"
              :placeholder="translate('services.blocked_simcard.reason')"
              :max-height="150"
          />
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <fg-input
              v-model="device_name"
              type="text"
              :label="translate('services.blocked_simcard.device')"
              :placeholder="translate('services.blocked_simcard.device')"
              :disabled="true"
          />
        </div>
      </div>
      <div class="row">
        <div class="col-md-4">
          <fg-input
              v-model="simcard_info.mno"
              type="text"
              :label="translate('services.blocked_simcard.mno')"
              :placeholder="translate('services.blocked_simcard.mno')"
              :disabled="true"
          />
        </div>
        <div class="col-md-4">
          <fg-input
              v-model="simcard_info.msisdn"
              type="text"
              :label="translate('services.blocked_simcard.msisdn')"
              :placeholder="translate('services.blocked_simcard.msisdn')"
              :disabled="true"
          />
        </div>
        <div class="col-md-4">
          <fg-input
              v-model="simcard_info.iccid"
              type="text"
              :label="translate('services.blocked_simcard.iccid')"
              :placeholder="translate('services.blocked_simcard.iccid')"
              :disabled="true"
          />
        </div>
      </div>

      <div class="text-center buttons">
        <span
            v-if="reason !== null && reason !== undefined"
            class="btn btn-success btn-fill btn-wd"
            @click.prevent="update_simcard()"
        >
          {{ translate("btn.edit") }}
        </span>
        <span
            class="btn btn-danger btn-fill btn-wd"
            @click.prevent="cancel()"
        >
          {{ translate("btn.close") }}
        </span>
      </div>
      <div class="clearfix"/>
    </div>
  </div>
</template>
<script>

const fields_to_check = ["status", "reason"];

export default {
  name: "AddBlockedSimCard",
  data() {
    return {
      reason: null
    }
  },
  props: {
    simcard_info: {
      type: [Object, Array],
      default: {}
    },
    device_name: {
      type: String,
      default: ""
    },
    tariffed_device_info_id: {
      type: Number,
      default: null
    },
  },

  computed:{
    reason_list(){
      return this.$store.getters.getBlockedSimcardReason.map((reason) => {
        return {id: reason.id, label: reason.title}
      })
    },
  },

  methods: {
    update_simcard(){
      let params = {
        simcard_profile_id: this.simcard_info.simcard_profile_id,
        device_tariffication_id: this.tariffed_device_info_id,
        reason: this.reason
      }
      this.$http.v1.addBlockedSimcardDevices(params, () => {
        this.global_notify("info", this.translate("services.blocked_simcard.simcard_blocked"));
        this.$emit('update')
      })
    },
    cancel() {
      this.$emit('close')
    },
  }
}
</script>
<style lang="scss" scoped>
.modal_card {
  width: 100%;
  border-radius: 3px;
  box-shadow: 0 2px 2px rgba(204, 197, 185, 0.5);
  color: #252422;
  position: relative;
  border: 1px solid #ccc;
  min-height: 85px;
  background-color: #f8f8f8;
  padding: 10px;

  .header {
    .title {
      margin-top: 5px;
      text-align: center;
    }
  }

  .content {
    .row {
      margin-bottom: 10px;
      display: flex;
      align-items: flex-end;
      justify-content: center;
      .icon{
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: center;

        span.mdi{
          font-size: 20px;
          &.online{
            color: #15ab00;
          }
          &.tariffication{
            color: #3f93d3;
          }
        }
      }

      .mx-input {
        width: 100%;
      }

      .form-group {
        margin: 0;
      }
    }
  }
  .buttons{
    .btn {
      height: 40px;
      margin-right: 5px;
      &:last-child{
        margin-right: 0;
      }
    }
  }
}

</style>
